module.exports = __webpack_public_path__ + "a1471d1d6431c893582a5f6a250db3f9.woff";


//////////////////
// WEBPACK FOOTER
// ./node_modules/typeface-roboto/files/roboto-latin-300.woff
// module id = 660
// module chunks = 0